function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.707 0.293C10.5195 0.105529 10.2652 0.000213623 9.99999 0.000213623C9.73483 0.000213623 9.48052 0.105529 9.29299 0.293L5.99999 3.586L2.70699 0.293C2.51839 0.110842 2.26579 0.0100477 2.00359 0.0123261C1.74139 0.0146045 1.49058 0.119773 1.30517 0.305182C1.11976 0.49059 1.01459 0.741402 1.01232 1.0036C1.01004 1.2658 1.11083 1.5184 1.29299 1.707L4.58599 5L1.29299 8.293C1.19748 8.38525 1.1213 8.49559 1.06889 8.6176C1.01648 8.7396 0.988893 8.87082 0.987739 9.0036C0.986585 9.13638 1.01189 9.26806 1.06217 9.39095C1.11245 9.51385 1.1867 9.6255 1.28059 9.71939C1.37449 9.81329 1.48614 9.88754 1.60904 9.93782C1.73193 9.9881 1.86361 10.0134 1.99639 10.0123C2.12917 10.0111 2.26039 9.98351 2.38239 9.9311C2.5044 9.87869 2.61474 9.80251 2.70699 9.707L5.99999 6.414L9.29299 9.707C9.48159 9.88916 9.73419 9.98995 9.99639 9.98767C10.2586 9.9854 10.5094 9.88023 10.6948 9.69482C10.8802 9.50941 10.9854 9.2586 10.9877 8.9964C10.9899 8.7342 10.8891 8.4816 10.707 8.293L7.41399 5L10.707 1.707C10.8945 1.51947 10.9998 1.26516 10.9998 1C10.9998 0.734836 10.8945 0.480528 10.707 0.293Z",
  fill: "#000"
});

function SvgCloseXIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseXIcon);
export default __webpack_public_path__ + "static/media/close-x-icon.7a733fec.svg";
export { ForwardRef as ReactComponent };